import { RichText } from '@uswitch/ev-core/react'
import richTextFieldHasContent from '@uswitch/ev-utils/lib/rich-text/has-content'
import richTextStyles from '@uswitch/ev-utils/lib/rich-text/styles'

const HeaderFooterWrapper = ({
  heading,
  footer,
  headerStyles,
  footerStyles,
  wrapperStyles = { py: 'sm' },
  children,
}) => (
  <div sx={wrapperStyles}>
    <If condition={richTextFieldHasContent(heading)}>
      <RichText
        content={heading}
        style={{ display: 'block', pb: 'lg', ...richTextStyles, ...headerStyles }}
      />
    </If>

    {children}

    <If condition={richTextFieldHasContent(footer)}>
      <RichText
        content={footer}
        style={{ display: 'block', pt: 'lg', ...richTextStyles, ...footerStyles }}
      />
    </If>
  </div>
)

export default HeaderFooterWrapper
